import React from 'react';

import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
import './InventarioDocuPDF.css';
import alphalogo from '../../../utils/alphahorizontal.png'


const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    },
    viewcard:{
        display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            marginTop: "10px",
                 marginBottom: "5px",
                 backgroundColor: "#f9f8f8",
                 border: "1px solid #e2e2e2"
    },
    text:{
        fontSize:"9",
        color:"#03178c",
        fontWeight:"bold"
    },
    textdos:{
        fontSize:"7",
        color:"#03178c",
        fontWeight:"light"
    },
    itemelement:{
        width: "15%",
        marginRight:"1%",
        alignItems:"start"
    },
    vieWgeneral:{
        padding:"10px",
        
    },
    viewTitulo:{
        alignItems:"center"
    },
    imagenlogo:{
        width:"200px",
        height:"50px"
    },
    textotitulo:{
        color:"#03178c",
        fontSize:"18",
        fontWeight:"bold"
    },
    pageGeneral:{
        padding:"10px",
    }
  });
  
  function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const ubicacionA = a.nombre.toUpperCase();
    const ubicacionB = b.nombre.toUpperCase();
  
    let comparison = 0;
    if (ubicacionA > ubicacionB) {
      comparison = 1;
    } else if (ubicacionA < ubicacionB) {
      comparison = -1;
    }
    return comparison;
  } 


const InventarioDocuPDF = ({ repuestos }) => {
  
    let repuestosordenados=repuestos.sort(compare);
   

    let mapeorepuestos=
    (repuestosordenados.length>0?(
        repuestosordenados.map((repuesto)=>
        <View  style={styles.viewcard}>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Codigo</Text>
            <Text style={styles.textdos}>{repuesto.codigo}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Nombre</Text>
            <Text style={styles.textdos}>{repuesto.nombre}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Marca</Text>
            <Text style={styles.textdos}>{repuesto.marca}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Modelo</Text>
            <Text style={styles.textdos}>{repuesto.modelo}</Text>
            </View>

            <View style={styles.itemelement}>
            <Text style={styles.text} >Serie</Text>
            <Text style={styles.textdos}>{repuesto.serie}</Text>
            </View>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Cantidad</Text>
            <Text style={styles.textdos}>{repuesto.cantidad}</Text>
            </View>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Valor Unt</Text>
            <Text style={styles.textdos}>${repuesto.valorunitario}</Text>
            </View>
            <View style={styles.itemelement}>
            <Text style={styles.text} >Proveedor</Text>
            <Text style={styles.textdos}>{repuesto.proveedor}</Text>
            </View>

        
        </View>
       
        )
    ):(<View>
            <Text>no hay nada</Text>
    </View>)
    )
  
  
    return (

        <Document>
             <Page size="a4" style={styles.pageGeneral}>
             
            <View style={styles.vieWgeneral}>
                <View style={styles.viewTitulo}>
     
                <Image src={alphalogo} style={styles.imagenlogo}></Image>
                <Text style={styles.textotitulo}>Listado de Repuestos</Text>
                </View>
               {mapeorepuestos}
            </View>
            </Page>
         </Document>
        
        
        )
}

export default InventarioDocuPDF